import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { PlusArticleTypeTitle } from "scmp-app/components/plus/plus-article-type-title";

export const Summary = styled.div`
  color: #333333;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 20px;
  line-height: 130%;
`;

export const ContentLink = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 8px;

  cursor: pointer;
`;

export const StyledPlusArticleTypeTitle = styled(PlusArticleTypeTitle)`
  text-transform: uppercase;
`;

export const Footer = styled.div`
  color: #888888;
  font-size: 14px;
  line-height: 16px;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const CoverLink = styled.div`
  position: relative;

  color: #000000;

  border-radius: 4px;

  cursor: pointer;

  img {
    inline-size: 200px;

    border-radius: 4px;
  }
`;

export const Cover = styled.div`
  inline-size: 200px;
  min-inline-size: 200px;

  border-radius: 4px;

  overflow: hidden;
  aspect-ratio: 3 / 2;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  font-family: ${fontRobotoCondensed};
`;
